<app-page-content class="independent-scroll-page">
<app-doenkids-menu-bar menuBar [showBackButton]="true" [loading]="( activityLoading$ | async ) || ( forkingActivity$ | async )">
  <div class="flex-row items-center" left>
    <!-- Actions Menu for mobile/smaller screens -->
    <button
      mat-icon-button
      [matMenuTriggerFor]="actionsMenu"
      [matTooltip]="'activity.preview.actions' | translate"
      class="actions-menu-button"
      >
      <mat-icon>more_vert</mat-icon>
    </button>

    <mat-menu #actionsMenu="matMenu" class="vertical-actions-menu">
      @if ((isOwner$ | async) && (hasOUWritePermission$ | async)) {
        <button mat-menu-item (click)="edit()">
          <mat-icon>edit</mat-icon>
          <span>{{ 'activity.preview.edit.tooltip' | translate }}</span>
        </button>
      }
      @if ((isOwner$ | async) && (hasOUWritePermission$ | async) && (activityDetails$ | async)?.status_id !== EActivityStatusType.CONCEPT) {
        <button mat-menu-item (click)="backToDrawingBoard()">
          <mat-icon>replay</mat-icon>
          <span>{{ 'activity.preview.back_to_concept.tooltip' | translate }}</span>
        </button>
      }
      @if ((isEditor$ | async) && (hasOUWritePermission$ | async) && (activityDetails$ | async)?.status_id === EActivityStatusType.REVIEW) {
        <button mat-menu-item (click)="approveActivity()">
          <mat-icon>done</mat-icon>
          <span>{{ 'activity.preview.approve.tooltip' | translate }}</span>
        </button>
      }
      @if (!(isOwner$ | async) && (hasActivityCopyPermission$ | async) && (hasOUWritePermission$ | async)) {
        @if ((activityDetails$ | async)?.replace_activity_id === null) {
          <button mat-menu-item (click)="forkActivity()">
            <mat-icon>call_split</mat-icon>
            <span>{{ 'activity.preview.copy.create.tooltip' | translate }}</span>
          </button>
        }
        @if ((activityDetails$ | async)?.replace_activity_id !== null) {
          <button mat-menu-item (click)="unforkActivity()">
            <mat-icon>call_split</mat-icon>
            <span>{{ 'activity.preview.copy.remove.tooltip' | translate }}</span>
          </button>
        }
        @if (forkedId && (activityDetails$ | async)?.replace_activity_id === null && (isManagement$ | async)) {
          <button mat-menu-item (click)="navigateToForkedActivity()">
            <mat-icon>call_split</mat-icon>
            <span>{{ 'activity.preview.copy.show.tooltip' | translate }}</span>
          </button>
        }
      }
      @if (isLinkedWihtJibbie$ | async) {
        @if (isActivityLinkedWithJibbie$ | async) {
          <button mat-menu-item (click)="unlinkWithJibbie()">
            <mat-icon svgIcon="jibbie-linked"></mat-icon>
            <span>{{ 'activity.preview.jibbie.unlink.tooltip' | translate }}</span>
          </button>
        }
        @if (!(isActivityLinkedWithJibbie$ | async)) {
          <button mat-menu-item (click)="linkWithJibbie()">
            <mat-icon svgIcon="jibbie-unlinked"></mat-icon>
            <span>{{ 'activity.preview.jibbie.link.tooltip' | translate }}</span>
          </button>
        }
      }
      @if (isOwner$ | async) {
        <button mat-menu-item (click)="reviewByOrganisation()">
          <mat-icon>preview</mat-icon>
          <span>{{ 'activity.preview.review.by_organization.tooltip' | translate }}</span>
        </button>
      }
      <button mat-menu-item [disabled]="(pdf$ | async) === ''" (click)="downloadPDF()">
        <mat-icon>get_app</mat-icon>
        <span>{{ 'activity.preview.pdf.download.tooltip' | translate }}</span>
      </button>
      @if (!(isReader$ | async) && (isLocation$ | async) && (activityDetails$ | async)?.status_id === publishedStatus) {
        <button mat-menu-item (click)="createProgram()">
          <mat-icon>date_range</mat-icon>
          <span>{{ 'activity.create-program.tooltip' | translate }}</span>
        </button>
      }
      @if (!forkedId && !(isOwner$ | async) && !(isCurrentOrganizationUnitIsOfTypeLocation$ | async) && !(isCurrentOrganizationUnitIsOfTypeGroup$ | async) && !(isRevokedInNodePath$ | async)) {
        <button mat-menu-item (click)="excludeActivity()">
          <mat-icon>remove_circle</mat-icon>
          <span>{{ 'activity.exclude.tooltip' | translate }}</span>
        </button>
      }
      @if (!forkedId && !(isOwner$ | async) && !(isCurrentOrganizationUnitIsOfTypeLocation$ | async) && !(isCurrentOrganizationUnitIsOfTypeGroup$ | async) && (isRevokedInNodePath$ | async)) {
        <button mat-menu-item (click)="restoreActivity()">
          <mat-icon>add_circle</mat-icon>
          <span>{{ 'activity.preview.restore.tooltip' | translate }}</span>
        </button>
      }
      @if ((isOwner$ | async) && !(isReader$ | async)) {
        <button mat-menu-item (click)="deleteActivity()">
          <mat-icon>delete</mat-icon>
          <span>{{ 'activity.preview.delete.tooltip' | translate }}</span>
        </button>
      }
    </mat-menu>

    <!-- Individual action buttons for larger screens -->
    <div class="individual-actions">
    @if ((isOwner$ | async) && (hasOUWritePermission$ | async)) {
      <button
        mat-icon-button
        (click)="edit()"
        [matTooltip]="'activity.preview.edit.tooltip' | translate"
      >
        <mat-icon>edit</mat-icon>
      </button>
    }
    @if ((isOwner$ | async) && (hasOUWritePermission$ | async) && (activityDetails$ | async)?.status_id !== EActivityStatusType.CONCEPT) {
      <button
        mat-icon-button
        (click)="backToDrawingBoard()"
        [matTooltip]="'activity.preview.back_to_concept.tooltip' | translate"
      >
        <mat-icon>replay</mat-icon>
      </button>
    }
    @if ((isEditor$ | async) && (hasOUWritePermission$ | async) && (activityDetails$ | async)?.status_id === EActivityStatusType.REVIEW) {
      <button
        mat-icon-button
        (click)="approveActivity()"
        [matTooltip]="'activity.preview.approve.tooltip' | translate"
      >
        <mat-icon>done</mat-icon>
      </button>
    }
    @if (!(isOwner$ | async) && (hasActivityCopyPermission$ | async) && (hasOUWritePermission$ | async)) {
      @if ((activityDetails$ | async)?.replace_activity_id === null) {
        <button
          mat-icon-button
          type="button"
          (click)="forkActivity()"
          [matTooltip]="'activity.preview.copy.create.tooltip' | translate"
        >
          <mat-icon class="icon-btn">call_split</mat-icon>
        </button>
      }
      @if ((activityDetails$ | async)?.replace_activity_id !== null) {
        <button
          mat-icon-button
          type="button"
          (click)="unforkActivity()"
          [matTooltip]="'activity.preview.copy.remove.tooltip' | translate"
        >
          <mat-icon class="icon-btn-selected">call_split</mat-icon>
        </button>
      }
      @if (forkedId && (activityDetails$ | async)?.replace_activity_id === null && (isManagement$ | async)) {
        <button
          mat-icon-button
          type="button"
          (click)="navigateToForkedActivity()"
          color="primary"
          [matTooltip]="'activity.preview.copy.show.tooltip' | translate"
        >
          <mat-icon class="icon-btn">call_split</mat-icon>
        </button>
      }
    }

    <!-- START: Jibbie button section -->
    @if (isLinkedWihtJibbie$ | async) {
      @if (isActivityLinkedWithJibbie$ | async) {
        <button
          [matTooltip]="'activity.preview.jibbie.unlink.tooltip' | translate"
          (click)="unlinkWithJibbie()"
          mat-icon-button
          type="button"
        >
          <mat-icon svgIcon="jibbie-linked"></mat-icon>
        </button>
      }
      @if (!(isActivityLinkedWithJibbie$ | async)) {
        <button
          [matTooltip]="'activity.preview.jibbie.link.tooltip' | translate"
          (click)="linkWithJibbie()"
          mat-icon-button
          type="button"
        >
          <mat-icon svgIcon="jibbie-unlinked"></mat-icon>
        </button>
      }
    }
    <!-- END: Jibbie button section -->

    @if (isOwner$ | async) {
      <button
        [matTooltip]="'activity.preview.review.by_organization.tooltip' | translate"
        (click)="reviewByOrganisation()"
        mat-icon-button
        type="button"
      >
        <mat-icon>preview</mat-icon>
      </button>
    }
    <button
      mat-icon-button
      type="button"
      [disabled]="(pdf$ | async) === ''"
      (click)="downloadPDF()"
      [matTooltip]="'activity.preview.pdf.download.tooltip' | translate"
    >
      <mat-icon>get_app</mat-icon>
    </button>
    @if (!(isReader$ | async) && (isLocation$ | async) && (activityDetails$ | async)?.status_id === publishedStatus) {
      <button
        mat-icon-button
        type="button"
        (click)="createProgram()"
        [matTooltip]="'activity.create-program.tooltip' | translate"
      >
        <mat-icon>date_range</mat-icon>
      </button>
    }
    </div>

    @if (activityOwner$ | async; as owner) {
      <app-owner-chip [owningOuId]="owner.organization_unit_id"></app-owner-chip>
    }
    @if ((activityStatus$ | async) === EActivityStatusType.REVIEW && (activityCopies$ | async)?.length > 0) {
      <button
        [matTooltip]="'activity.preview.view_copies.tooltip' | translate"
        [matMenuTriggerFor]="activityCopies"
        mat-icon-button
        type="button"
      >
        <mat-icon>account_tree</mat-icon>
      </button>
    }
    <mat-menu class="activity-copy-menu" #activityCopies="matMenu">
      @if (activityCopies$ | async; as activityCopies) {
        @for (activityCopy of activityCopies; track activityCopy.id) {
          @if ((activityCopy.owner_organization_unit_id ?? [])[0] && this.activityCopyOuName[activityCopy.owner_organization_unit_id[0]]) {
            <span mat-menu-item>
              {{ this.activityCopyOuName[activityCopy.owner_organization_unit_id[0]] }}
            </span>
          }
        }
      }
    </mat-menu>

    <!-- Activity review source-->
    @if ((activityDetails$ | async)?.status_id === EActivityStatusType.REVIEW && (activityCreatedByOU || activityCreatedByUser)) {
      <button mat-stroked-button class="status-chip review">
        {{ 'activity.preview.review.created_by' | translate : { activityCreatedByUser, activityCreatedByOU } }}
      </button>
    }
  </div>
  <div right>
    @if (!forkedId && !(isOwner$ | async) && !(isCurrentOrganizationUnitIsOfTypeLocation$ | async) && !(isCurrentOrganizationUnitIsOfTypeGroup$ | async) && !(isRevokedInNodePath$ | async)) {
      <button
        mat-icon-button
        type="button"
        (click)="excludeActivity()"
        [matTooltip]="'activity.exclude.tooltip' | translate"
      >
        <mat-icon>remove_circle</mat-icon>
      </button>
    }
    @if (!forkedId && !(isOwner$ | async) && !(isCurrentOrganizationUnitIsOfTypeLocation$ | async) && !(isCurrentOrganizationUnitIsOfTypeGroup$ | async) && (isRevokedInNodePath$ | async)) {
      <button
        mat-icon-button
        type="button"
        (click)="restoreActivity()"
        [matTooltip]="'activity.preview.restore.tooltip' | translate"
      >
        <mat-icon>add_circle</mat-icon>
      </button>
    }

    @if ((isOwner$ | async) && !(isReader$ | async)) {
      <button mat-icon-button type="button" (click)="deleteActivity()" [matTooltip]="'activity.preview.delete.tooltip' | translate">
        <mat-icon>delete</mat-icon>
      </button>
    }
  </div>
</app-doenkids-menu-bar>
<div content>

<app-split-page
  [activeTab]="0"
  [leftLabel]="'activity.preview.tab.details' | translate"
  [rightLabel]="'activity.preview.tab.preview' | translate"
  [scrollEventsLeft]="false"
  [scrollEventsRight]="false"
  [independentScroll]="true"
  (selectedTabChange)="renderPdf()"
>
  <ng-template #left>
    <div class="sections-container">
      <!-- Outdated Activity Warning Banner (only for creators/admins) -->
      @if ((canSeeOutdatedBanner$ | async) && (bannerInfo$ | async); as bannerInfo) {
        <div
          class="outdated-banner"
          [class.outdated-banner--deleted]="bannerInfo.isDeleted"
          [class.outdated-banner--updated]="bannerInfo.isUpdated"
          [style.display]="bannerInfo.shouldShow ? 'flex' : 'none'"
        >
          @if (bannerInfo.isDeleted) {
            <mat-icon>warning</mat-icon>
            <div class="outdated-banner__content">
              <strong>{{ 'activity.outdated.deleted.title' | translate }}</strong>
              <p>{{ 'activity.outdated.deleted.description' | translate }}</p>
            </div>
          }
          @if (bannerInfo.isUpdated) {
            <mat-icon>info</mat-icon>
            <div class="outdated-banner__content">
              <strong>{{ 'activity.outdated.updated.title' | translate }}</strong>
              <p>{{ 'activity.outdated.updated.description' | translate }}</p>
              <div class="outdated-banner__actions">
                <button
                  mat-stroked-button
                  color="primary"
                  (click)="viewOriginalActivity()"
                  class="outdated-banner__link"
                >
                  {{ 'activity.outdated.view_original' | translate }}
                </button>
                @if (!bannerInfo.isActivityArchived) {
                  <button
                    mat-raised-button
                    color="primary"
                    (click)="recopyActivity()"
                    class="outdated-banner__recopy"
                  >
                    {{ 'activity.outdated.recopy.button' | translate }}
                  </button>
                }
                <button
                  mat-button
                  (click)="dismissOriginalUpdatedNotification()"
                  class="outdated-banner__dismiss"
                >
                  {{ 'activity.outdated.dismiss' | translate }}
                </button>
              </div>
            </div>
          }
        </div>
      }
      @if (activityDetails$ | async; as activity) {
        <div class="details">
        <div class="main-details flex-col md-flex-row-reverse justify-between items-start">
          <div>
            <app-doenkids-image [maxHeight]="150" [maxWidth]="150" [mediaItem]="(activityDetails$ | async)?.media_uuid"> </app-doenkids-image>
            @if (reviewOverview$ | async; as reviewOverview) {
              <div
                [matTooltip]="'activity.preview.reviews.view.tooltip' | translate"
                (click)="scrollToReviews()"
                class="clickable"
              >
                @if (reviewOverview.review_score) {
                  <app-review-rating
                    [value]="reviewOverview.review_score"
                    [editable]="false"
                  ></app-review-rating>
                } @else {
                  {{ 'activity.preview.reviews.none' | translate }}
                }
              </div>
            }
          </div>
          <div class="title flex-col">
            <h1 [style.color]="headingColor">
              {{ activity.name !== '' ? activity.name : ('generic.new' | translate) }}
            </h1>
            <h2 [style.color]="subheadingColor">{{ activity.subtitle }}</h2>
            @if (activity.summary) {
              <p class="summary">
                <i>{{ activity.summary }}</i>
              </p>
            }
          </div>
        </div>

        @if (isManagement$ | async) {
          <app-activity-example-usage
            [usage]="exampleProgramTemplateUsage$ | async"
            [loading]="(exampleProgramTemplateUsageLoading$ | async) ?? false"
            [maxUsageCount]="maxExampleUsageCount"
          ></app-activity-example-usage>
        }
        </div>
      }
      @for (section of mediaSections$ | async; track section.id) {
        <div>
          @if (section.data?.title) {
            <h2 [style.color]="headingColor">{{ section.data?.title }}</h2>
          }
          @if (section.data?.subtitle) {
            <h2 [style.color]="subheadingColor">{{ section.data?.subtitle }}</h2>
          }

          <!-- Videos -->
          @for (safeUrl of section.data?.video; track $index) {
            @if (safeUrl && safeUrl.length > 1) {
              <div class="video-cards animated fadeIn">
                @if (safeUrl) {
                  <iframe [src]="safeUrl | safe : 'resourceUrl'"></iframe>
                }
              </div>
            }
          }
        </div>
      }
      @for (section of notMediaSections$ | async; track section.id) {
        <div>
          @if (section.data?.title) {
            <h2 [style.color]="headingColor">{{ section.data?.title }}</h2>
          }
          @if (section.data?.subtitle) {
            <h2 [style.color]="subheadingColor">{{ section.data?.subtitle }}</h2>
          }
          @switch (section.type_id) {
            @case (ESectionType.GLOSSARY) {
              {{ section.data?.terms }}
              @for (term of section.data?.term; track term.name) {
                <div>
                  <b>{{ term.name }}</b
                  ><span>{{ term.description }}</span>
                </div>
              }
            }
            @case (ESectionType.SOURCES) {
              @for (source of section.data?.source; track $index) {
                <div>
                  <a [href]="source" target="_blank">{{ source }}</a>
                </div>
              }
            }
            @case (ESectionType.MEDIA) {
              <div class="media-container">
                @for (media of section.data?.media; track media.uuid) {
                  @if (media?.uuid) {
                    <mat-card appearance="outlined" class="media-item">
                      <app-doenkids-image [maxHeight]="150" [maxWidth]="150" [mediaItem]="media?.uuid" class="media-image"> </app-doenkids-image>
                      @if (media.description) {
                        <br />
                        <i>{{ media.description }}</i>
                      }
                    </mat-card>
                  }
                }
              </div>
            }
            @default {
              @if (section.data?.content) {
                <div [innerHTML]="section.data?.content" class="ql-editor"></div>
              }
            }
          }
        </div>
      }

      <!-- Attachements in metaData card-->
      <div class="attachments">
        @if ((activityAttachments$ | async).length > 0) {
          <h2>
            {{ 'generic.attachments' | translate }}
          </h2>
        }
        <div class="attachment-container">
          @for (attachment of activityAttachments$ | async; track attachment.id) {
            <div class="attachment">
              <div class="attachment-content-container">
                <mat-icon class="attachment-icon">insert_drive_file</mat-icon>
                <a class="attachment-link" (click)="openAttachment(attachment)">
                  <span>{{ attachment['filename'] }}</span>
                </a>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
    @if (activityDetails$ | async) {
      <div intersection (appear)="reviewsVisible$.next(true)" class="reviews" #reviewWrapper>
        @if (reviewsVisible$ | async) {
          <app-review-overview [reviewOverview]="reviewOverview$ | async" [preview]="true" [id]="(activityDetails$ | async)?.id">
          </app-review-overview>
        }
      </div>
    }
  </ng-template>

  <ng-template #right>
    <div class="pdf-container">
      <app-pdf-viewer
        [pdfSrc]="pdf$ | async"
        [loading]="pdfLoading"
        (pdfLoaded)="onPdfLoadedEvent()"
      ></app-pdf-viewer>
    </div>
  </ng-template>
</app-split-page>

</div>
</app-page-content>
